/**
 * Column definitions for the Incidents table.
 *
 * Follows the same shape as `src/containers/pages/customers/data/headTableCells.ts`.
 * Columns with `property: ''` render no TableSortLabel (not sortable).
 */
export const incidentsHeadTableCells = [
  { id: 1, property: '', label: '' },                   // expand/collapse toggle
  { id: 2, property: 'title', label: 'Title' },         // title + camera subtitle
  { id: 3, property: 'severity', label: 'Severity' },   // SeverityChip
  { id: 4, property: 'status', label: 'Status' },       // StatusChip
  { id: 5, property: 'created_at', label: 'Created' },  // relative time, sortable
];
